import axios, { AxiosResponse } from "axios";
import i18n from "../../i18n";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

export interface RegistrationRequest {
    firstname: string;
    lastname: string;
    email: string;
    phone?: string;
    password: string;
    role: any;
  }
  
  export const registerUser = async (data: RegistrationRequest): Promise<any> => {

    try {
      const token = Cookies.get("access_token");
      const response: AxiosResponse<any> = await apiClient.post(
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/auth/registration`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Ошибка при регистрации пользователя:", error);
      throw error;
    }
  };

  interface User {
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    role: string[];
    userId: number;
    disabled: boolean;
  }
  
  interface UserListResponse {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
    users: User[];
  }
  
  export const getUserList = async (page = 1, size = 1000): Promise<UserListResponse> => {
    try {
      const token = Cookies.get("access_token");
  
      const response: AxiosResponse<UserListResponse> = await apiClient.get(
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/user/list`,
        {
          params: { page, size },
          headers: {
            "Authorization": `Bearer ${token}`, // Добавляем Bearer токен
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении списка пользователей:", error);
      throw error;
    }
  };


  export const updateUser = async (userId: number, data: any): Promise<any> => {
    try {
      const token = Cookies.get("access_token");
      const response: AxiosResponse<any> = await apiClient.put(
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/user/${userId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Ошибка при обновлении данных пользователя:", error);
      throw error;
    }
  };


// Функция для удаления заблокированного пользователя
export const deleteUser = async (userId: number): Promise<void> => {
  try {
    const token = Cookies.get("access_token");
    const response: AxiosResponse<void> = await apiClient.delete(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/user/${userId}`,
      {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      }
    );

  } catch (error: any) {
    if (error.response && error.response.status === 400) {
      const { message, details } = error.response.data;
      console.error("Ошибка при удалении пользователя:", message, details);
    } else {
      console.error("Неизвестная ошибка при удалении пользователя:", error);
    }
    throw error;
  }
};
  